import React, { useRef, useState, useEffect, Suspense, Fragment } from "react";
import ShimmerLoader from "../ShimmerLoader";
const TreatmentDetails = React.lazy(() => import("."));

function TreatmentDetailsLazyLoadWrapper(props) {
  const {treatmentsTotal,Fullscreen,treatmentDetails,Highcharts,treatmentoptions,drugTotal,drugTherapy,druggoptions,biologicalTotal,
    biologicalTherapy,biooptions, TreatmentDetailsLoader} = props;
  const containerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);
   
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // TreatmentDetailsAPICall();
          observer.disconnect(); 
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }
    return () => observer.disconnect();
   /* eslint-disable-next-line react-hooks/exhaustive-deps */   
  }, []);
  return (
    <Fragment>
      <div ref={containerRef} 
      // style={{ minHeight: "500px" }}
      >
        {isVisible && (
           <Suspense fallback={<ShimmerLoader />}>
            {TreatmentDetailsLoader === true && <ShimmerLoader />}

            {TreatmentDetailsLoader === false && treatmentDetails && drugTotal  && drugTherapy &&  <TreatmentDetails
              treatmentsTotal={treatmentsTotal}
              Fullscreen={Fullscreen}
              treatmentDetails={treatmentDetails}
              Highcharts={Highcharts}
              treatmentoptions={treatmentoptions}
              drugTotal={drugTotal}
              drugTherapy={drugTherapy}
              druggoptions={druggoptions}
              biologicalTotal={biologicalTotal}
              biologicalTherapy={biologicalTherapy}
              biooptions={biooptions}
            />}
          </Suspense>
        )}
      </div>
    </Fragment>
  );
}

export default TreatmentDetailsLazyLoadWrapper;
